import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import axios from "axios";

function MarkDailyAttendance() {
  const [sewadar, setSewadar] = useState("");
  const [loading, setLoading] = useState(false);

  const [sewadarAttendance, setSewadarAttendance] = useState({});
  const [allowed, setAllowed] = useState(false);
  const history = useHistory();
  const [sewadarDetails, setSewadarDetails] = useState({});
  const [sewaDate, setSewaDate] = useState("");
  const [sewaInTime, setSewaInTime] = useState("");
  const [sewaOutTime, setSewaOutTime] = useState("");
  const [responseStatus, setResponseStatus] = useState("");

  const [items, setItems] = useState([]);
  const search = useRef(null);

  const [attendanceKey, setAttendanceKey] = useState(0);

  const roleNames = {
    CR: "Coordinator",
    ZI: "Zone Incharge",
    GI: "Group Incharge",
    NS: "Sewadar",
  };

  function markAttendance() {
    if (sewadar) {
      if (sewaDate === "" || sewaInTime === "" || sewaOutTime === "") {
        alert("Please enter all details");
        return;
      }
      setLoading(true);
      let payload = {
        sewadarBadge: sewadar,
        sewaDate: sewaDate,
        sewaInTime: sewaInTime,
        sewaOutTime: sewaOutTime,
        sewaMarkedBy: JSON.parse(localStorage.getItem("userdata")).username,
      };

      console.log({ payload });
      axios
        .post(
          "https://a9s48sduha.execute-api.ap-northeast-1.amazonaws.com/v1/daily/attendance",
          payload
        )
        .then(function (response) {
          console.log(response.data);
          if (response.data.status === "Success") {
            setSewadarAttendance(JSON.parse(response.data.body));
            setResponseStatus(response.data.status);

            resetData();
          } else if (response.data.status === "Failure") {
            setSewadarAttendance(JSON.parse(response.data.body));
            setResponseStatus(response.data.status);
          }
          setLoading(false);
        })
        .catch(function (error) {
          console.log(error);
          setLoading(false);
        });
      setLoading(false);
    }
  }
  useEffect(() => {
    if (localStorage.getItem("userdata")) {
      var userdata = JSON.parse(localStorage.getItem("userdata"));
      if (["ADMIN", "OFFICE"].includes(userdata.role)) {
        setAllowed(true);
        axios
          .post(
            "https://a9s48sduha.execute-api.ap-northeast-1.amazonaws.com/v1/daily/sewadar"
          )
          .then(function (response) {
            console.log(response.data.body);
            if (response.data.status === "success") {
              setItems(JSON.parse(response.data.body).sewadarList);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        setAllowed(false);
      }
    } else {
      history.push("/");
    }
  }, []);

  useEffect(() => {
    setSewaInTime("");
    setSewaOutTime("");
  }, [sewadar]);

  function resetData() {
    setAttendanceKey(attendanceKey + 1);
    setSewadarDetails({});
    setSewadar("");
    setSewaDate("");
    setSewaInTime("");
    setSewaOutTime("");
  }

  // useEffect(() => {
  //   if (
  //     ["ADMIN", "OFFICE"].includes(
  //       JSON.parse(localStorage.getItem("userdata")).role
  //     )
  //   ) {
  //     setAllowed(true);
  //     document.getElementById("sewadarBadge").focus();
  //   } else {
  //     setAllowed(false);
  //   }
  // }, []);
  const handleOnSearch = (string, results) => {
    // onSearch will have as the first callback parameter
    // the string searched and for the second the results.
    console.log(string, results);
  };

  const handleOnHover = (result) => {
    // the item hovered
    console.log(result);
  };

  const handleOnSelect = (item) => {
    // the item selected
    console.log(item);
    setSewadarDetails(item);
    setSewadar(item.id);
  };

  const handleOnFocus = () => {
    console.log("Focused");
  };

  const formatResult = (item) => {
    return (
      <>
        <span style={{ display: "block", textAlign: "left" }}>
          Badge: {item.id}
        </span>
        <span style={{ display: "block", textAlign: "left" }}>
          Name: {item.name}
        </span>
      </>
    );
  };

  const isSuccess = responseStatus === "Success";

  return (
    <div className="max-w-3xl mx-auto">
      <h1 className="page-title mb-5">Mark Daily Attendance</h1>

      <div className="bg-white rounded-lg shadow p-4 sm:p-6">
        <div className="grid grid-cols-12 gap-4">
          {/* Date */}
          <div className="col-span-12">
            <label
              htmlFor="sewaDate"
              className="form-label"
            >
              Sewa Date
            </label>
            <input
              type="date"
              name="sewaDate"
              id="sewaDate"
              className="form-input"
              value={sewaDate}
              onChange={(e) => setSewaDate(e.target.value)}
            />
          </div>

          {/* Sewadar search */}
          <div className="col-span-12">
            <label className="form-label">Sewadar</label>
            <form
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <ReactSearchAutocomplete
                key={attendanceKey}
                ref={search}
                items={items}
                onSearch={handleOnSearch}
                onHover={handleOnHover}
                onSelect={handleOnSelect}
                onFocus={handleOnFocus}
                autoFocus
                formatResult={formatResult}
                placeholder="Search Sewadar by name"
                fuseOptions={{
                  keys: ["name"],
                  threshold: 0.2,
                }}
              />
            </form>
          </div>

          {/* Times (only after a sewadar is selected) */}
          {Object.keys(sewadarDetails).length > 0 && (
            <>
              <div className="col-span-12 sm:col-span-6">
                <label
                  htmlFor="sewaInTime"
                  className="form-label"
                >
                  In Time
                </label>
                <input
                  type="time"
                  name="sewaInTime"
                  id="sewaInTime"
                  className="form-input"
                  value={sewaInTime}
                  onChange={(e) => setSewaInTime(e.target.value)}
                />
              </div>
              <div className="col-span-12 sm:col-span-6">
                <label
                  htmlFor="sewaOutTime"
                  className="form-label"
                >
                  Out Time
                </label>
                <input
                  type="time"
                  name="sewaOutTime"
                  id="sewaOutTime"
                  className="form-input"
                  value={sewaOutTime}
                  onChange={(e) => setSewaOutTime(e.target.value)}
                />
              </div>
            </>
          )}

          {/* Submit */}
          <div className="col-span-12 mt-2">
            {!loading ? (
              <button
                type="button"
                onClick={() => markAttendance()}
                className="btn-primary"
              >
                <i className="fas fa-check-circle" />
                Mark Attendance
              </button>
            ) : (
              <div className="flex justify-center">
                <img
                  src="/images/loading.gif"
                  alt="loading"
                  className="w-10 h-10"
                />
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Result */}
      {Object.keys(sewadarAttendance).length > 0 && (
        <div className="mt-6 bg-white rounded-lg shadow overflow-hidden">
          {sewadarAttendance.message && (
            <div
              className={
                "flex items-center gap-2 px-4 py-3 font-semibold text-white " +
                (isSuccess ? "bg-green-500" : "bg-red-500")
              }
            >
              <i
                className={
                  "fas " +
                  (isSuccess ? "fa-check-circle" : "fa-exclamation-circle")
                }
              />
              {sewadarAttendance.message}
            </div>
          )}

          <dl className="divide-y divide-gray-100">
            <div className="grid grid-cols-12 gap-2 px-4 py-3">
              <dt className="col-span-12 sm:col-span-4 text-sm font-semibold text-gray-500">
                Sewadar
              </dt>
              <dd className="col-span-12 sm:col-span-8 text-lg font-bold text-gray-800">
                {sewadarAttendance.sewadarBadge} -{" "}
                {sewadarAttendance.sewadarName}
              </dd>
            </div>
            <div className="grid grid-cols-12 gap-2 px-4 py-3">
              <dt className="col-span-12 sm:col-span-4 text-sm font-semibold text-gray-500">
                Sewa Date
              </dt>
              <dd className="col-span-12 sm:col-span-8 text-lg font-bold text-gray-800">
                {sewadarAttendance.sewaDate}
              </dd>
            </div>
            <div className="grid grid-cols-12 gap-2 px-4 py-3">
              <dt className="col-span-12 sm:col-span-4 text-sm font-semibold text-gray-500">
                In / Out Time
              </dt>
              <dd className="col-span-12 sm:col-span-8 text-lg font-bold text-gray-800">
                {sewadarAttendance.sewaInTime} - {sewadarAttendance.sewaOutTime}
              </dd>
            </div>
          </dl>
        </div>
      )}
    </div>
  );
}
export default MarkDailyAttendance;
